// 1280 800
export const Desktop = 800
export const Desktop600 = 600
export const S2MaxWidth = 500
